import { useEffect, useState } from "react";
import { Logout } from "./Logout";

interface SidebarProps {
  items: { id: string; label: string }[];
  activeItem: string;
  onItemClick: (id: string) => void;
}

export const Sidebar = ({ items, activeItem, onItemClick }: SidebarProps) => {
  const [userEmail, setUserEmail] = useState<string | null>(null);

  useEffect(() => {
    // Cloudflare Zero Trust (Access) 環境では認証はネットワークレイヤーで完了しています。
    setUserEmail("Administrator");
  }, []);

  return (
    <div className="w-64 bg-white h-screen shadow-lg flex flex-col">
      <div className="p-6 border-b">
        <h2 className="text-xl font-bold text-gray-800">管理画面</h2>
        {userEmail && (
          <p className="text-xs text-gray-500 mt-1 truncate">{userEmail}</p>
        )}
      </div>
      <nav className="flex-1 overflow-y-auto p-4">
        <ul className="space-y-2">
          {items.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => onItemClick(item.id)}
                className={`w-full text-left px-4 py-2 rounded-md transition-colors ${
                  activeItem === item.id
                    ? "bg-blue-500 text-white"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>
      <div className="p-4 border-t">
        <Logout />
      </div>
    </div>
  );
};
